import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import './styles/style.css'; // Custom CSS for slider
import { toast, ToastContainer } from 'react-toastify';
import { useQuery, useQueryClient} from '@tanstack/react-query';
import ReactModal from 'react-modal';
import imageCompression from 'browser-image-compression';

function FamilyInfoUpdateTotemAdd() {

    const { menu, toggleMobileMenu } = useAppLayout();
    
    const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const navigate = useNavigate();
  const queryClient = useQueryClient();


 const [totemName, setTotemName] = useState('');
  const [imageFile, setImageFile] = useState(null); // optional image



  
const handleImageChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    // Compression options
    const options = {
      maxSizeMB: 1,             // Compress to around 1MB
      maxWidthOrHeight: 800,    // Resize max dimension
      useWebWorker: true,       // Faster compression
    };

    // Compress image
    const compressedFile = await imageCompression(file, options);

    // Save compressed file in state
    setImageFile(compressedFile);

    // Preview the compressed image
    const reader = new FileReader();
    reader.onload = (e) => {
      document.getElementById("blah").src = e.target.result;
    };
    reader.readAsDataURL(compressedFile);

  } catch (err) {
    console.error("Image compression error:", err);
    toast.error("Failed to compress image.");
  }
};


  
  const [isSubmitting, setIsSubmitting] = useState(false);


  const handleTotemSubmit = async () => {
    if (!totemName.trim()) {
      toast.error("Please enter your totem name.");
      return;
    }
  
    setIsSubmitting(true);
  
    try {
      const formData = new FormData();
      formData.append("totem_name", totemName);
  
      if (imageFile) {
        // Compress image to ~100KB
        const options = {
          maxSizeMB: 0.1,           // 0.1 MB ≈ 100 KB
          maxWidthOrHeight: 800,    // keep a reasonable resolution
          useWebWorker: true,
        };
  
        const compressedImage = await imageCompression(imageFile, options);
  
        // Append compressed image instead of original
        formData.append("image", compressedImage, imageFile.name);
      }
  
      const res = await axios.post(`${API_URL}/reg-signup-nototem-api`, formData, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      if (res.data.Status === "Success") {
        navigate(res.data.redirect);
      } else {
        toast.error(res.data.Message || "Failed to register clan.");
      }
    } catch (error) {
      console.error("Totem submission error:", error);
      toast.error("Something went wrong.");
    } finally {
      setIsSubmitting(false);
    }
  };

   

    return (
            <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />

                <div className="page-wrapper">
                    <div className="content container-fluid">

                    <div className="vstack gap-3">

                    <div className='row'>

                    <div className='col-3 col-md-3'>
                        </div>
                    
                                <div className='col-6 col-md-6'>
                    
                                         <div className='card'>
                                                          <div className='card-body'>
                                        
                                                            <p style={{ fontWeight: '900', paddingBottom: '20px'}}><center>You can register your new totem here</center></p>
                                        
                                        
                                                            <div className='row' style={{ marginTop: "20%" }}>
                                                            <center>
                                                    <div className="profile-pic-wrapper "  >
                                                      <label
                                                        htmlFor="avatar_upload"
                                                        className="avatar avatar-xxl profile-cover-avatar-square"
                                                        style={{
                                                          height: "150px",
                                                          width: "100%",
                                                          position: "relative",
                                                          cursor: "pointer",
                                                          display: "inline-block",
                                                        }}
                                                      >
                                                        <img
                                                          id="blah"
                                                          src="https://oret.africa/tree/img/imageplaceholder-icon.jpg"
                                                          alt=""
                                                          className="avatar-img"
                                                          style={{
                                                            height: "150px",
                                                            width: "100%",
                                                            objectFit: "cover",
                                                            backgroundColor: "#fff",
                                                          }}
                                                        />
                                                        <input
                                                          type="file"
                                                          name="image"
                                                          id="avatar_upload"
                                                          accept="image/*"
                                                          style={{ display: "none" }}
                                                          onChange={handleImageChange}
                                                        />
                                                        <span
                                                          className="avatar-edit"
                                                          style={{
                                                            position: "absolute",
                                                            bottom: "5px",
                                                            right: "5px",
                                                            backgroundColor: "#184A2C",
                                                            color: "#fff",
                                                            borderRadius: "50%",
                                                            padding: "8px",
                                                          }}
                                                        >
                                                          <i className="fas fa-edit avatar-uploader-icon shadow-soft"></i>
                                                        </span>
                                                      </label>
                                                      
                                                      
                                                      
                                                    </div>
                                        
                                                    <label>Upload Totem Image (optional)</label>
                                                  </center>
                                                            </div>
                                        
                                        
                                                      <input
                                                            type="text"
                                                            className="form-control mt-3"
                                                            placeholder="Enter Totem Name"
                                                            value={totemName}
                                                            onChange={(e) => setTotemName(e.target.value)}
                                                            
                                                            onFocus={(e) => e.target.scrollIntoView({ behavior: 'smooth', block: 'center' })}
                                                          />
                                        
                                        <div className="d-flex justify-content-between align-items-center mt-4">
                                          <Link onClick={() => navigate(-1)} className="btn btn-secondary">Back</Link>
                                        
                                          <button onClick={handleTotemSubmit} 
                                           type="button"
                                            className="btn btn-primary"
                                            disabled={isSubmitting}
                                          >
                                            {isSubmitting ? "Updating..." : "Update"}
                                          </button>
                                        </div>
                                        
                                        
                                        
                                                            </div>
                                                            </div>
                    
                                </div>
                    
                                 
                                </div>

                    </div>
                    </div>
                </div>
            </div>
        
    );
}

export default FamilyInfoUpdateTotemAdd;
